import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import PageHeading from "../components/page-heading"
import Button from "../components/button"
import Gallery from "../components/gallery"
import GradiLink from "../components/gradi-link"
import { GatsbyImage } from "gatsby-plugin-image";
import { normalizePath } from "../utils/get-url-path"
import StockistsForm from "../components/stockists-form"
import Seo from 'gatsby-plugin-wpgraphql-seo';

const Stockists = ({ data, pageContext: { currentBrand, id } }) => {
  const { wpPage } = data
  const  { uri, title, slug, customContent } = wpPage
  const { wholesaleAndStockists } = customContent
  const {
    ourRangeParagraph,
    stockists: stockistsGroup,
    images,
    wholesaleEnquiriesParagraph,
  } = wholesaleAndStockists

  const { stockists, stockistsParagraph, onlineLink } = stockistsGroup

  // return (
  //   <Layout currentBrand={currentBrand}>
  //     <PageHeading>{title}</PageHeading>
  //     <div className="flex flex-col gap-20">
  //       <div className="grid grid-cols-1 gap-10 md:gap-0 md:grid-cols-2">
  //         <div className="flex md:pr-24 flex-col gap-10 justify-space-between order-2 md:order-1">
  //           <div className="uppercase">
  //             <span className="font-bold">wholesale enquiries</span>
  //             <div className="whitespace-pre-wrap">
  //               {stockistsParagraph}
  //             </div>
  //           </div>
  //         </div>
  //         <div className="order-1 md:order-2">
  //           <Gallery gallery={images} />
  //         </div>
  //       </div>
  //     </div>
  //   </Layout>
  // )
  const sectionClass = "py-10"
  
  const pageOptions = { stockistsList: false }

  let builtGroup = {}

  if (stockists) {
    stockists.forEach(stockist => {
      const { country, state } = stockist
      if (!builtGroup[country]) {
        builtGroup[country] = {}
      }
      if (!builtGroup[country][state]) {
        builtGroup[country][state] = []
      }
      builtGroup[country][state].push(stockist)
    })
  }

  return (
    <Layout currentBrand={currentBrand}>
      <Seo post={wpPage} />
      <PageHeading>Wholesale &amp; Stockists</PageHeading>
      <div className="flex flex-col gap-20">
        <div className="grid grid-cols-1 gap-5 lg:gap-0 lg:grid-cols-2">
          <div className="flex lg:pr-24 flex-col gap-10 justify-space-between order-2 lg:order-1">
            <div className="uppercase flex flex-col gap-5">
              <span className="font-bold">wholesale enquiries</span>
              <div>{wholesaleEnquiriesParagraph}</div>
              <StockistsForm currentBrand={currentBrand} />
            </div>
          </div>
          <div className="order-1 md:order-2">
            <Gallery gallery={images} />
          </div>
        </div>

        <div className="uppercase">
          <div>
            <div className="font-bold pb-5">stockists</div>

            <div className="whitespace-pre-wrap mb-5">{stockistsParagraph}</div>

            <div className="py-2 mb-20">
              {onlineLink ? (
                <>
                  <div className="font-bold">online</div>
                  <GradiLink
                    underline
                    to={onlineLink.url}
                    target={onlineLink.target}
                  >
                    {onlineLink.title}
                  </GradiLink>
                </>
              ) : (
                <></>
              )}
            </div>

            {pageOptions.stockistsList ? (
              <div style={{ columnCount: 2 }}>
                {Object.keys(builtGroup).map((key, i) => (
                  <>
                    <span className="font-bold">{key}</span>
                    {Object.keys(builtGroup[key]).map((innerKey, i) => (
                      <>
                        <br />
                        {" / "}
                        {innerKey}
                        {builtGroup[key][innerKey].map(stockist => {
                          const { name, location } = stockist
                          return (
                            <div>
                              {name}{" "}
                              <GradiLink newWindow underline to={stockist.link}>
                                {location}
                              </GradiLink>
                            </div>
                          )
                        })}
                      </>
                    ))}
                  </>
                ))}
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default Stockists

export const query = graphql`query stockistsQuery($id: String) {
  wpPage(id: {eq: $id}) {
    id
    link
    title
    uri
    nodeType
    slug
    ...SeoFields
    customContent {
      wholesaleAndStockists {
        brandStyle
        ourRangeParagraph
        wholesaleEnquiriesParagraph
        stockists {
          stockistsParagraph
          onlineLink {
            url
            title
            target
          }
          stockists {
            state
            phoneNumber
            location
            name
            link
            country
            address
          }
        }
        images {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
}
`
